import { useTranslation } from "react-i18next";
import "./Overview.scss";

export default function Overview() {
	const { t } = useTranslation();

	return (
		<section id="overview" className="section">
			<div className="container">
				<h2>{t("overview.title")}</h2>

				<p>{t("overview.text")}</p>

				<p className="overview__secondary">{t("overview.secondary")}</p>
			</div>
		</section>
	);
}
